import { headType } from "./head-type.enum";


export enum preference {
    yes = 'yes',
    no = 'no',
    optional = 'optional'
}

export interface HeadType {
    type: headType,
    bays: number,
    coreDiffBays: number,
    orientationConfig?: {
        shift: number,
        corridorCornerDistance: number,
    },
    width?: number,
    length?: number,
    preferred?: preference,
    highrise?: boolean, // > 20m.
}

export const defaultHead = headType.H_2C_XL;

export const headTypesModel: HeadType[] = [
    {
        type: headType.none,
        bays: 0,
        width: 0,
        coreDiffBays: 0,
        orientationConfig: {
            shift: 0,
            corridorCornerDistance: 0,
        },
        highrise: true,
    },
    {
        type: headType.H_2C_XL,
        bays: 6,
        coreDiffBays: 0,
        width: 11.9,
        length: 20.4,
        orientationConfig: {
            shift: 0,
            corridorCornerDistance: 10.2,
        },
        preferred: preference.no,
        highrise: true,
    },
    {
        type: headType.H_2C_S1S2,
        bays: 6,
        coreDiffBays: 0,
        width: 11.9,
        length: 20.4,
        orientationConfig: {
            shift: 0,
            corridorCornerDistance: 10.2,
        },
        preferred: preference.no,
        highrise: true,
    },
    {
        type: headType.H_C_S1S2,
        bays: 3,
        coreDiffBays: 0,
        width: 10.2,
        length: 10.2,
        orientationConfig: {
            shift: 0,
            corridorCornerDistance: 5.1,
        },
        preferred: preference.no,
        highrise: true,
    },
]